import { render, staticRenderFns } from "./PaginaResumenRespuestasMuniIngresadas.vue?vue&type=template&id=f8408aa2"
import script from "./PaginaResumenRespuestasMuniIngresadas.vue?vue&type=script&lang=js"
export * from "./PaginaResumenRespuestasMuniIngresadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports